import React from 'react';

const ContentObjective = ({ objective, selectedTranslationIndex }) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>
    <div className="ql-editor" dangerouslySetInnerHTML={{__html: objective.translations[selectedTranslationIndex].description}}/>
  </div>
);

export default ContentObjective
